// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const BreakpointIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="BreakpointIcon" ref={forwardedRef} {...props}>
      <path d="M17.25 10a7.25 7.25 0 1 1-14.5 0 7.25 7.25 0 0 1 14.5 0" />
    </SvgIcon>
  );
});

/**
 * Use for Live Debugging
 * @public
 */
export const BreakpointIcon = /* @__PURE__ */ Object.assign(
  BreakpointIconComponent,
  { displayName: 'BreakpointIcon' },
);
